export { StoreProductPage } from "./components/StoreProductPage";
